import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';

export default function LiabilityWaiverDialog({
  triggerText = 'terms',
  className,
}: {
  triggerText?: string;
  className?: string;
}) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className={
            className ??
            'font-medium underline underline-offset-2 hover:text-primary'
          }
        >
          {triggerText}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent
        onClick={(e) => e.stopPropagation()}
        className="max-w-lg"
      >
        <AlertDialogHeader>
          <AlertDialogTitle>Release of Liability</AlertDialogTitle>
          <AlertDialogDescription className="text-left leading-relaxed">
            I RELEASE AND FOREVER DISCHARGE Onefinity CNC, and Kirbre
            Enterprises Inc., including their past and present officers,
            employees, and representatives (the &ldquo;Releasees&rdquo;), from
            all liability for personal injury and/or harm, or property damage
            arising from my participation in the FileFinity Program. This
            includes any claims related to my handling of CNC files related
            thereto. I further agree to indemnify and defend the Releasees
            against any claims caused by my own actions, whether negligent or
            intentional. This waiver applies to me, my family, and my heirs.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction>I understand</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
